import { useEffect } from 'react';
import { OverlayAppletCapability, type Specs } from '@doxyme/extensions-bridge';
import {
  useIsAppletLoaded,
  useAddCapability,
  useBasicObservable,
} from '@doxyme/extensions-bridge-react';
import { bridge } from '../../../features/extensions/instances';

type Applet = Specs.OverlayApplet.Applet;

export type UseExtensionsOverlayAppletReturnType = {
  applet: Applet | undefined;
  isLoaded: boolean;
};

export function useExtensionsOverlayApplet(): UseExtensionsOverlayAppletReturnType {
  const overlayApplet = useAddCapability(
    bridge,
    () => new OverlayAppletCapability(),
  );

  const [applet] = useBasicObservable<Applet | undefined>(
    overlayApplet.getActiveFrame(),
  );

  const { isLoaded } = useIsAppletLoaded(applet);

  // Override body overflow when applet is present
  useEffect(() => {
    document.body.style.overflow = applet ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [applet]);

  return {
    applet,
    isLoaded,
  };
}
